module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/vip3-80f65bd6f1dcb2659c51a36f92e12810.png";